import { servicePost } from "./client.ts";

export interface PlanogramSlot {
  SlotID: number;
  ShelfID: number;
  Sensor: number;
  WeightType: number;
  Rentable: boolean;
  Disabled: boolean;
  Name: string;
  ProductID: number;
  ProductCount: number;
  ProductWeight: number;
  MaxProductCount: number;
  MinX: number;
  MaxX: number;
  MinY: number;
  MaxY: number;
  DisabledText?: string;
  RentableText?: string;
  ProductText?: string;
}

export interface PlanogramDiff {
  Name: string;
  Current: string;
  NewValue: string;
}

export interface Planogram {
  ID: number;
  KioskID: number;
  OperatorID: number;
  KioskRevision: string;
  Identifier: string;
  Name: string;
  ConfigDataSerialized: PlanogramSlot[];
  ConfigType: string;
  Created: string;
  IsBase: boolean;
  Deleted: boolean;
  DiffData: PlanogramDiff[];
}

export interface PlanogramPush {
  ID: number;
  ConfigID: number;
  KioskID: number;
  Synced: boolean;
  Pushed: string;
  PushedBy: string;
  Deleted: boolean;
}

export function getDiffPlanograms() {
  return servicePost<Planogram[]>("WebGetDiffPlanograms", {});
}

export function getBasePlanograms() {
  return servicePost<Planogram[]>("WebGetBasePlanograms", {});
}

export function getPlanogram(id: number) {
  return servicePost<Planogram>("WebGetPlanogram", { id });
}

export function savePlanogram(plan: Planogram) {
  return servicePost<boolean>("WebSavePlanogram", { plan });
}

export function pushPlanogram(id: number, kioskID: number) {
  return servicePost<PlanogramPush[]>("WebPushPlanogram", { id, kioskID });
}

export function getPlanogramPushHistory(id: number) {
  return servicePost<PlanogramPush[]>("WebGetPlanogramPushHistory", { id });
}

/** An UNSAVED planogram (`ID` = -1) seeded from a kiosk's live state: slot geometry from
 *  the kiosk's active planogram (what the kiosk matches on when a push is applied),
 *  product and capacity per slot from its latest inventory snapshot. `oData` is null
 *  when the kiosk has no active planogram to take the geometry from. Used by Issa's
 *  `createPlanogram` chat action to pre-fill the planogram editor. */
export function getKioskInventoryPlanogram(kioskID: number) {
  return servicePost<Planogram | null>("WebGetKioskInventoryPlanogram", { kioskID });
}
